<style lang="scss">
.calendar {
  .calendar-header {
    display: flex;
    margin-bottom: 10px;

    .calendar-navigate {
      display: flex;
      justify-content: start;
      font-size: 2rem;
      width: 100%;

      .calendar-prev {
        margin-right: 10px;
      }

      .calendar-next {
        margin-left: 10px;
      }
    }
  }

  .calendar-body {
    .calendar-days-of-week {
      display: flex;

      .calendar-day-of-week {
        flex: 1;
        padding: 10px 0;
        text-transform: uppercase;
        text-align: center;
        border-top: 1px solid rgba(166, 168, 179, 0.12);
        font-weight: 600;
        border-bottom: 1px solid #b6c2c9;
      }
    }

    .calendar-days-of-month {
      .calendar-7-days {
        display: flex;
        border-top: solid 1px rgba(166, 168, 179, 0.12);

        .calendar-day {
          flex: 1;
          // margin: 5px;
          min-height: 100px;
          padding: 5px 15px;
          color: rgba(166, 168, 179, 0.12);
          border-left: solid 1px rgba(166, 168, 179, 0.12);

          &.in-current-month {
            color: inherit;
          }

          &.last-day-of-week {
            border-right: solid 1px rgba(166, 168, 179, 0.12);
          }

          .calendar-day-number {
            font-size: 1.5rem;

            &.is-today {
              color: #348fe2;
              font-size: 3rem;
              font-weight: 600;
            }
          }

          .calendar-day-info {
            font-size: 11px;
            padding-left: 0;
            margin-top: 6px;
            list-style: none;

            &__item {
              color: #fff;
              padding: 2px;
              border-radius: 3px;
              -webkit-box-shadow: 0px 11px 10px -9px rgba(0, 0, 0, 0.25);
              -moz-box-shadow: 0px 11px 10px -9px rgba(0, 0, 0, 0.25);
              box-shadow: 0px 11px 10px -9px rgba(0, 0, 0, 0.25);

              &.info__item__holiday {
                background-color: #ff5b57;
              }

              &.info__item__event {
                background-color: #00acac;
              }

              &.info__item__exam_schedule {
                background-color: #348fe2;
              }
            }
          }
        }

        &.last-week-of-month {
          border-bottom: solid 1px rgba(166, 168, 179, 0.12);
        }
      }
    }
  }
}
</style>

<template>
  <div>
    <ts-card>
      <div class="calendar">
        <ts-card-wrapper>
          <div class="calendar-header">
            <div class="calendar-navigate">
              <div class="calender-headline">{{ month }} {{ year }}</div>
            </div>
            <div class="calendar-navigate">
              <a
                href="#"
                v-tooltip="$t('calendar.previousMonth')"
                class="calendar-prev text-primary"
                @click.prevent="previous"
              >
                <i class="fas fa-chevron-left"></i>
              </a>
              <ts-button
                @click.prevent="toDay"
                outline
                class="btn-white p-l-40 p-r-40"
                >{{ $t('calendar.today') }}</ts-button
              >
              <a
                href="#"
                v-tooltip="$t('calendar.nextMonth')"
                class="calendar-next text-primary"
                @click.prevent="next"
              >
                <i class="fas fa-chevron-right"></i>
              </a>
            </div>
            <b-dropdown dropdown variant="outline-default" no-caret right>
              <template v-slot:button-content>
                <i class="fas fa-align-justify"></i>
              </template>
              <b-dropdown-item @click.prevent="showPublicHoliday">
                <i class="fas fa-plane"></i> {{ $t('calendar.publicHoliday') }}
              </b-dropdown-item>
              <b-dropdown-item @click.prevent="showSchoolEvent">
                <i class="fas fa-building"></i>
                {{ $t('calendar.schoolEvent') }}
              </b-dropdown-item>
              <b-dropdown-item @click.prevent="showExamSchedule">
                <i class="fas fa-chalkboard-teacher"></i>
                {{ $t('calendar.examSchedule') }}
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <div class="calendar-body">
            <div class="calendar-days-of-week">
              <div class="calendar-day-of-week">{{ $t('Monday') }}</div>
              <div class="calendar-day-of-week">{{ $t('Tuesday') }}</div>
              <div class="calendar-day-of-week">{{ $t('Wednesday') }}</div>
              <div class="calendar-day-of-week">{{ $t('Thursday') }}</div>
              <div class="calendar-day-of-week">{{ $t('Friday') }}</div>
              <div class="calendar-day-of-week">{{ $t('Saturday') }}</div>
              <div class="calendar-day-of-week">{{ $t('Sunday') }}</div>
            </div>
            <div class="calendar-days-of-month">
              <div
                v-for="(dates, index7days) in datesOfMonth"
                :key="index7days"
                class="calendar-7-days"
                :class="{
                  'last-week-of-month': index7days === datesOfMonth.length - 1
                }"
              >
                <div
                  v-for="(date, indexDay) in dates"
                  :key="indexDay"
                  class="calendar-day"
                  :class="[
                    { 'in-current-month': inCurrentMonth(date) },
                    { 'last-day-of-week': indexDay === dates.length - 1 }
                  ]"
                >
                  <span
                    class="calendar-day-number"
                    :class="{ 'is-today': isToday(date) }"
                    >{{ date.format('D') }}</span
                  >
                  <ul class="calendar-day-info">
                    <li
                      v-for="(event, eventIndex) in getInfo(date)"
                      :key="eventIndex"
                      class="calendar-day-info__item m-b-2"
                      :class="[
                        {
                          info__item__holiday:
                            event.event_type.toLowerCase() == 'holiday'
                        },
                        {
                          info__item__event:
                            event.event_type.toLowerCase() == 'event'
                        },
                        {
                          info__item__exam_schedule:
                            event.event_type.toLowerCase() == 'exam schedule'
                        }
                      ]"
                    >
                      <span>{{ event.description }}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </ts-loading-banner>
      </div>
    </ts-card>
    <div class="row">
      <div class="col-lg-3 col-md-6 col-xs-12">
        <div class="ts-text-sm m-t-15 m-b-5">{{ $t('calendar.legend') }}</div>
        <ul class="list-group">
          <li class="list-group-item">
            <i class="fas fa-circle text-danger mx-2"></i>
            {{ $t('calendar.publicHoliday') }}
          </li>
          <li class="list-group-item">
            <i class="fas fa-circle text-success mx-2"></i>
            {{ $t('calendar.schoolEvent') }}
          </li>
          <li class="list-group-item">
            <i class="fas fa-circle text-primary mx-2"></i>
            {{ $t('calendar.examSchedule') }}
          </li>
        </ul>
      </div>
      <div class="col-lg-6 col-md-6 col-xs-12">
        <div class="ts-text-sm m-t-15 m-b-5">
          {{ $t('calendar.upcomingPlan') }}
        </div>
        <EventList :events="eventsOftheMonth" />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
import EventList from './event-list'
import PublicHoliday from './public-holiday'
import SchoolEvent from './school-event'
import ExmaSchedule from './exam-schedule'
import { debounce } from 'lodash'

export default {
  name: 'Calendar',
  components: { EventList },
  data() {
    return {
      loading: false,
      student_id: null,
      currentDate: moment()
    }
  },
  computed: {
    ...mapState('calendar', ['events']),
    datesOfMonth() {
      let date = []

      for (
        let i = moment(this.currentDate)
          .startOf('month')
          .weekday();
        i > 0;
        i--
      ) {
        date.push(
          moment(this.currentDate)
            .startOf('month')
            .add(i * -1, 'days')
        )
      }

      for (
        let j = 0;
        j <
        moment(this.currentDate)
          .endOf('month')
          .format('DD');
        j++
      ) {
        date.push(
          moment(this.currentDate)
            .startOf('month')
            .add(j, 'days')
        )
      }

      for (
        let k = 1;
        k <=
        6 -
          moment(this.currentDate)
            .endOf('month')
            .weekday();
        k++
      ) {
        date.push(
          moment(this.currentDate)
            .endOf('month')
            .add(k, 'days')
        )
      }

      return _.chunk(date, 7)
    },
    inCurrentMonth: vm => date => {
      return date.format('MM') === moment(vm.currentDate).format('MM')
    },
    month() {
      return this.currentDate.format('MMMM')
    },
    year() {
      return this.currentDate.format('YYYY')
    },
    isToday: () => date => {
      return moment().format('DD-MM-YYYY') == moment(date).format('DD-MM-YYYY')
    },
    eventsOftheMonth() {
      return this.events.filter(
        ev =>
          moment(ev.start_date).format('MM YYYY') ===
          moment(this.currentDate).format('MM YYYY')
      )
    },
    isStaff() {
      return this.$store.getters.isStaffLogin
    },
    isParent() {
      return this.$store.getters.isParentLogin
    },
    isStudent() {
      return this.$store.getters.isStudentLogin
    },
    isTeacher() {
      return this.$store.getters.isTeacherLogin
    },
    selectedStudent() {
      return this.$store.state.selectedStudent.student_id
    }
  },
  created() {
    if (this.isParent) {
      this.student_id = this.$store.state.selectedStudent.student_id
    }
    if (this.isStudent) {
      this.student_id = this.$store.state.home.student.profile.student_id
    }
    if (this.isStaff || this.isTeacher) {
      this.loadEvent()
    }
  },
  methods: {
    showPublicHoliday() {
      this.$modal.show(
        PublicHoliday,
        {
          data: []
        },
        {
          height: 'auto',
          width: '50%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    },
    showSchoolEvent() {
      this.$modal.show(
        SchoolEvent,
        {
          data: []
        },
        {
          height: 'auto',
          width: '50%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    },
    showExamSchedule() {
      this.$modal.show(
        ExmaSchedule,
        {
          data: []
        },
        {
          height: 'auto',
          width: '50%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    },
    loadEvent(attributes) {
      this.loading = true
      this.$store
        .dispatch(
          'calendar/fetch',
          Object.assign(
            {
              year: this.currentDate.format('YYYY'),
              month: this.currentDate.format('MM')
            },
            { ...attributes }
          )
        )
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    getInfo(date) {
      if (this.events.length == 0) return
      return this.events
        .reduce((result, event) => {
          let days = this.calculateDayInterval(event.start_date, event.end_date)

          for (let day = 0; day <= days; day++) {
            result.push(
              Object.assign({}, event, {
                start_date: moment(event.start_date)
                  .add(day, 'days')
                  .format('YYYY-MM-DD')
              })
            )
          }

          return result
        }, [])
        .filter(event => event.start_date == date.format('YYYY-MM-DD'))
    },
    previous() {
      this.currentDate = moment(this.currentDate).add(-1, 'months')
    },
    next() {
      this.currentDate = moment(this.currentDate).add(1, 'months')
    },
    toDay() {
      this.currentDate = moment()
    },
    calculateDayInterval(fromDate, toDate) {
      return moment.duration(moment(toDate).diff(moment(fromDate))).as('days')
    }
  },
  watch: {
    currentDate: function(val) {
      if (val) {
        if (this.student_id) {
          this.loadEvent({
            year: val.format('YYYY'),
            month: val.format('MM'),
            student_id: this.student_id
          })
        } else {
          this.loadEvent({ year: val.format('YYYY'), month: val.format('MM') })
        }
      }
    },
    student_id: debounce(function(value) {
      this.loadEvent({ student_id: value })
    }, 500),
    selectedStudent: debounce(function() {
      if (this.isParent) {
        this.student_id = null
        this.student_id = this.$store.state.selectedStudent.student_id
      }
    }, 500)
  }
}
</script>
